import AudioFullWidth from './component.jsx'
export default AudioFullWidth
